import { SCHOOL_URL } from "../../../../crud/helpers/routes";
import {
  getMultipartParams,
  handleResponse,
} from "../../../../crud/helpers/validate";

const useTeams = () => {
  const getTeams = (setterFunction, slug) => {
    return fetch(
      `${SCHOOL_URL}/${slug}/teams?per_page=100`,
      getMultipartParams("GET")
    )
      .then((res) => handleResponse(res))
      .then((json) => setterFunction(json.items))
      .catch((e) => {
        console.error(e?.errors ?? e);
        return e;
      });
  };

  return { getTeams };
};

export default useTeams;
